module.exports = __webpack_public_path__ + "img/instagram.2682a0c7.svg";